import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "50",
  viewBox: "0 0 50 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M29.61 28.188c5.068 0 9.192 3.524 9.192 7.858V50H35.2V36.046c0-2.307-2.558-4.256-5.59-4.256h-9.218c-3.032 0-5.59 1.949-5.59 4.256V50H11.2V36.046c0-4.334 4.124-7.858 9.192-7.858h9.218zm-1.749-23.82A11.221 11.221 0 0134.77 9.59a11.114 11.114 0 011.162 8.501c-1.33 5.04-5.92 8.39-10.932 8.39-.944 0-1.9-.12-2.856-.367a11.214 11.214 0 01-6.908-5.223 11.11 11.11 0 01-1.162-8.5c1.578-5.99 7.758-9.593 13.788-8.024zm-2.86 3.235c-3.416 0-6.542 2.277-7.448 5.707a7.546 7.546 0 00.79 5.762 7.639 7.639 0 004.706 3.556c4.096 1.068 8.326-1.377 9.402-5.455a7.551 7.551 0 00-.79-5.764 7.639 7.639 0 00-4.706-3.556 7.848 7.848 0 00-1.954-.25z"
  })]
});